<template>
  <div id="pageTable" class="mainView">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="complex.items"
                :rows-per-page-items="[10,25,50,100]"
                :total-items="totalItems"
                :pagination.sync="pagination"
                class="elevation-1"
                item-key="id"
                must-sort
                >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-center">{{ props.item.id }}</td>
                  <td class="text-sm-center">{{ props.item.name }}</td>
                  <td class="text-sm-center">{{ props.item.birthDay }}</td>
                  <td class="text-sm-center">{{ props.item.gender == 'M' ? '남자' : '여자'}}</td>
                  <td class="text-sm-center">{{ props.item.phoneNumber }}</td>
                  <td class="text-sm-center">{{ props.item.driverArea }}</td>
                  <td class="text-sm-center">{{ props.item.driverType }}</td>
                  <td class="text-sm-center" >
                    {{ props.item.businessNumber}}
                    <template v-if="props.item.businessNumber">
                      ({{props.item.businessNumber.length}})
                    </template>
                  </td>
                  <td class="text-sm-center">{{ props.item.taxi == null ? '-' : props.item.taxi.taxiNum }}</td>
                  <td class="text-sm-center">
                    <v-btn color="primary" dark @click="openDialogPicture(props.item.id)">보기</v-btn>
                  </td>
                  <td class="text-sm-center">
                    <v-btn color="primary" dark @click="showThumbnailModal(props.item.id)">보기</v-btn>
                  </td>
                  <td class="text-sm-center">
                    <v-btn color="primary" dark @click="openDialogLicense(props.item)">보기</v-btn>
                  </td>
                  <td class="text-sm-center">
                    <v-select
                      :items="state"
                      label="State"
                      item-text="text"
                      item-value="state"
                      single-line
                      :value="props.item.state"
                      @focus="savePrevState(props.item.state)"
                      @change="changeState(props.item.id, props.item.driverLicenseNumber, $event)">
                    </v-select>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-dialog v-model="picture.dialog" scrollable max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">본인 사진</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="min-height: 465px;">
              <img
                      alt="등록된 사진이 없습니다"
                      :src="pictureData"
                      width="469px"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer>
              </v-spacer>
              <v-btn color="blue darken-1" flat @click.native="picture.dialog = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="license.dialog" scrollable max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">자격증</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="min-height: 465px">
              <img
                      alt="등록된 사진이 없습니다"
                      :src="licenseData"
                      width="469px"
              />
            </v-card-text>

            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                          label="자격증번호"
                          name="driverLicenseNumber"
                          placeholder="자격증번호 입력"
                          v-model="formModel.driverLicenseNumber"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout wrap v-if="formModel.isDisplayCompanyField">
                <v-flex xs12>
                  <v-text-field
                          label="회사명"
                          name="companyName"
                          placeholder="회사명 입력"
                          v-model="formModel.companyName"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click.native="changeDriverLicenseNumberAndCompanyName()">Save</v-btn>
              <v-btn color="blue darken-1" flat @click.native="license.dialog = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>

    <ModalDriverImageThumbnail></ModalDriverImageThumbnail>
  </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import State  from '@/api/state';
const _helpers = require('../../../node_modules/vuetify/es5/util/helpers');
const _slicedToArray = require('../../../mock/sliceToArray');
import ModalDriverImageThumbnail from '../../components/modal/modal-driver-image-thumbnail';

export default {
  components: {
    VWidget, ModalDriverImageThumbnail
  },
  data () {
    return {
      pagination: {
        sortBy: 'id',
        descending: true,
        rowsPerPage: 10,
        page: 1
      },
      searchFormModel: {
        filter: 'state',
        filterText: 'PENDING'
      },
      totalItems: 0,
      pictureData: '',
      licenseData: '',
      formModel: {
        id: '',
        driverLicenseNumber: ''
      },
      curItem: null,
      prevState: '',
      complex: {
        headers: [
          {
            text: '회원 고유번호',
            value: 'id',
            align: 'center'
          },
          {
            text: '이름',
            value: 'name',
            align: 'center',
            sortable: false
          },
          {
            text: '생년월일',
            value: 'birthDay',
            align: 'center',
            sortable: false
          },
          {
            text: '성별',
            value: 'gender',
            align: 'center',
            sortable: false
          },
          {
            text: '휴대전화번호',
            value: 'phoneNumber',
            align: 'center'
          },
          {
            text: '영업지역',
            value: 'driverArea',
            align: 'center'
          },
          {
            text: '소속',
            value: 'driverType',
            align: 'center'
          },
          {
            text: '개인사업자번호(운수사번)',
            value: 'businessNumber',
            sortable: false,
            align: 'center'
          },
          {
            text: '택시 정보',
            value: 'taxiNum',
            align: 'center',
            sortable: false
          },
          {
            text: '본인사진',
            value: '',
            align: 'center',
            sortable: false
          },
          {
            text: '본인사진(썸네일)',
            value: '',
            align: 'center',
            sortable: false
          },
          {
            text: '자격증',
            value: '',
            align: 'center',
            sortable: false
          },
          {
            text: '심사 상태',
            value: 'state',
            align: 'center',
            sortable: false
          },
        ],
        items: []
      },
      picture: {
        dialog: false
      },
      license: {
        dialog: false
      },
      state: State
    };
  },
  watch: {
    pagination: {
      handler () {
        if (top.getApp.prevPageName === 'ScreeningPage') {
          if(top.getApp.prevPagination != null) {
            this.pagination = top.getApp.prevPagination;
          }

          if(top.getApp.prevSearchFormModel != null) {
            this.searchFormModel = top.getApp.prevSearchFormModel;
          }

          top.getApp.clearPrevData();
        }

        this.banbanCreated();
      },
      deep: true
    }
  },
  mounted () {
    for (let i = 0; i < this.$parent.$children.length; i++) {
      if (this.$parent.$children[i].chkAutoReload != null) {
        this.$parent.$children[i].chkAutoReload();
      }
    }
  },
  methods: {
    banbanCreated () {
      const parameters = {
        method: 'searchDrivers',
        pageNum: this.pagination.page - 1,
        pageSize: this.pagination.rowsPerPage,
        sortName: this.pagination.sortBy,
        order: this.pagination.descending == true ? 'desc' : 'asc',
        filter: this.searchFormModel.filter,
        filterText: this.searchFormModel.filterText
      };
      this.$store.dispatch('banbanAPI', parameters)
              .then(({ data }) => {
                if (data.statusCode != null && data.statusCode != '200'){
                  throw data.message;
                }

                this.complex.items = data.content;
                this.totalItems = data.totalElements;
                top.getApp.progress.dialog = false;
              })
              .catch((error) => {
                if (top.getApp.commonError == null) {
                  alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
                }
                top.getApp.commonError = null;
                top.getApp.progress.dialog = false;
              });
    },
    openDialogPicture (id) {
      this.pictureData = apiHost.adminApiHost + '/attach/view/DRIVER_PICTURE/' + id + '?v' + Math.random();
      this.picture.dialog = true;
    },
    openDialogLicense (item) {
      this.licenseData = apiHost.adminApiHost + '/attach/view/DRIVER_LICENSE/' + item.id + '?v' + Math.random();
      this.formModel.id = item.id;
      this.formModel.driverLicenseNumber = item.driverLicenseNumber;
      this.formModel.companyName = item.companyName;
      this.formModel.isDisplayCompanyField = item.driverType === 'COMPANY' ? true : false;
      this.curItem = item;
      this.license.dialog = true;
    },
    changeState (id, driverLicenseNumber, state) {
      if (state == 'ACTIVE' 
          && (driverLicenseNumber == '' || driverLicenseNumber == undefined)) {
        alert('자격증 번호를 저장해야 심사를 통과할 수 있습니다.');
        this.banbanCreated();
      } else {
        const prameters = {
          method: 'changeState',
          'id': id,
          'userState': state
        };
        this.$store.dispatch('banbanAPI', prameters)
          .then(({ data }) => {
            top.getApp.progress.dialog = false;
          })
          .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
            top.getApp.progress.dialog = false;
          });
      }
    },
    changeDriverLicenseNumberAndCompanyName () {
      let driverLicenseNumber = this.formModel.driverLicenseNumber;
      let companyName = this.formModel.companyName;

      if(!driverLicenseNumber) {
        alert('자격증번호를 정확하게 입력해 주세요.');
        return;
      } else if(this.formModel.isDisplayCompanyField && !companyName ) {
        alert('회사명을 정확하게 입력해 주세요.');
        return;
      }

      const parameters = {
        method: 'changeDriverLicenseNumberAndCompanyName',
        'id': this.formModel.id,
        'driverLicenseNumber': driverLicenseNumber,
        'companyName': companyName
      };
      this.$store.dispatch('banbanAPI', parameters)
        .then(({ data }) => {
          this.curItem.driverLicenseNumber = driverLicenseNumber;
          this.curItem.companyName = companyName;
          this.license.dialog = false;
          top.getApp.progress.dialog = false;

          alert('저장되었습니다.');
        });
    },
    savePrevState (prevState) {
      this.prevState = prevState;
    },
    showThumbnailModal (id) {
      this.$modal.show('modal-driver-image-thumbnail', {driverId : id});
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/screening/Screening.vue